import { AllieIconProps } from '../../../components';

export const StarsIcon: React.FC<AllieIconProps> = () => (
  <svg
    className="stroke-icon"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="stars-02" clipPath="url(#clip0_651_2496)">
      <path
        id="Icon"
        // eslint-disable-next-line max-len
        d="M2.99992 14.6667V11.3334M2.99992 4.66671V1.33337M1.33325 3.00004H4.66659M1.33325 13H4.66659M8.66659 2.00004L7.51047 5.00595C7.32246 5.49477 7.22846 5.73918 7.08227 5.94476C6.95271 6.12697 6.79352 6.28617 6.61131 6.41573C6.40572 6.56191 6.16131 6.65591 5.67249 6.84392L2.66659 8.00004L5.67249 9.15616C6.16131 9.34417 6.40572 9.43817 6.61131 9.58435C6.79352 9.71391 6.95271 9.87311 7.08227 10.0553C7.22846 10.2609 7.32246 10.5053 7.51047 10.9941L8.66659 14L9.82271 10.9941C10.0107 10.5053 10.1047 10.2609 10.2509 10.0553C10.3805 9.87311 10.5397 9.71391 10.7219 9.58435C10.9274 9.43817 11.1719 9.34417 11.6607 9.15616L14.6666 8.00004L11.6607 6.84392C11.1719 6.65591 10.9274 6.56191 10.7219 6.41573C10.5397 6.28617 10.3805 6.12697 10.2509 5.94476C10.1047 5.73918 10.0107 5.49477 9.8227 5.00595L8.66659 2.00004Z"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_651_2496">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
